/**
 * @fileoverview
 * Perform side effects that occur when internal events are triggered.
 */

const events = require('./events');
const effects = require('./effects');

function attachListeners() {
  events.once(events.constants.CART_ADD_ITEM, effects.preloadCheckoutAssets);
  events.once(events.constants.CART_LOCALIZED, effects.preloadCheckoutAssets);
}

module.exports = {
  attachListeners,
};



// WEBPACK FOOTER //
// ./static/js/v0/listeners.js